<!--  -->
<template>
  <div class="check-network" v-if="showCheckNetwork">
    
    <div class="check-network__content">
      <div class="menu">
        <span class="menu__title" @click="getPermission">赛前检测</span>
        <span class="menu__close" @click="hide()"></span>
      </div>
      <div class="box">
        <span class="box__title">基本信息</span>
        <span class="box__item">公网服务：
          {{ commonSpeed }}
          <Status :type="commonStatus" />
        </span>
        <span class="box__item">赛事网络：<Status :type="competitionStatus" />{{ competitionSpeed }}</span>
        <span class="box__item">题目服务：<Status :type="projectStatus" />{{ projectSpeed }}</span>
        <span class="box__item">云服务：<Status :type="aliStatus" />{{ aliSpeed }}</span>
      </div>
      <div class="box">
        <span class="box__title">授权信息</span>
        <span class="box__item">摄像头权限<Status type="author" :author="checkVideo" /></span>
        <span class="box__item">录音权限<Status type="author" :author="checkAudio"/></span>
      </div>
      <div class="line"></div>
      <div class="check-network__result">
        <span class="title">检测结果</span>
        <span>{{ result }}</span>
      </div>
      <div class="button" @click="hide()">我已知晓</div>
    </div>
  </div>
</template>

<script>
import {
  getSpeedWithImg
} from '@/utils/checkNetwork';
import Status from './Status';

export default {
  data () {
    return {
      result: '',
      showCheckNetwork: false,
      checkAudio: false,
      checkVideo: false,
      commonSpeed: '',
      commonStatus: 'loading',
      competitionSpeed: '',
      competitionStatus: 'loading',
      projectSpeed: '',
      projectStatus: 'loading',
      aliSpeed: '',
      aliStatus: 'loading',
      messageObj: {
        0: '网络速度偏慢，比赛答题可能会收到影响，建议更换网络',
        1: '网络速度适中，做题时可能稍有卡顿，但不影响整体答题！',
        2: '网络状态良好',
      },
    };
  },

  components: { Status },

  computed: {},
  watch: {
    showCheckNetwork() {
      this.getSpeed()
    }
  },
  mounted() {
    // this.getSpeed()
    this.getPermission()
  },

  methods: {
    getPermission() {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        .then(() => { 
          this.checkVideo = true;
          this.checkAudio = true;
        })
        .catch(() => { 
          this.checkVideo = false;
          this.checkAudio = false;
        })
    },
    hasGetUserMedia() {
      return !!(navigator.getUserMedia || navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia || navigator.msGetUserMedia);
    },
    show() {
      this.showCheckNetwork = true
    },
    hide() {
      this.showCheckNetwork = false
    },
    getSpeed() {
      const time = new Date().getTime()
      return Promise.all([
        getSpeedWithImg(`http://himg.bdimg.com/sys/portrait/item/2cdfb691.jpg?time=${time}`, 4.1),
        getSpeedWithImg(`https://cdn.xiaohoucode.com/prod-env/images/coding-cloud-competition/module/5a68102691e6b69ee48ea421da4907ad.jpeg?time=${time}`, 4.1),
        getSpeedWithImg(`https://app-cdn.playcodemonkey.cn/assets/signup/btn_monkey_no_groupcode-ceb279705667ab46277472329beb4ba7671ade103cad4361157568d99ca8cf4c.png?time=${time}`, 4.2),
        getSpeedWithImg(`https://codingcloud.oss-cn-zhangjiakou.aliyuncs.com/asserts/icon-portrait.png?time=${time}`, 101),
      ])
        .then(speed => {
          this.commonStatus = this.getStatus(speed[0])
          this.competitionStatus =  this.getStatus(speed[1])
          this.projectStatus =  this.getStatus(speed[2])
          this.aliStatus =  this.getStatus(speed[3])
          this.commonSpeed = `${speed[0]}kb/s`,
          this.competitionSpeed = `${speed[1]}kb/s`,
          this.projectSpeed = `${speed[2]}kb/s`,
          this.aliSpeed = `${speed[3]}kb/s`
          this.checkRules()
        })
    },
    getStatus(speed) {
      if (speed <= 80) {
        return 'failed'
      }
      if(80 < speed < 256) {
        return 'warning'
      }
      if (speed >= 256) {
        return 'success'
      }
    },
    checkRules() {
      const baseArr = [
        this.commonStatus,
        this.competitionStatus,
        this.projectStatus,
        this.aliStatus,
      ]
      let result1 = baseArr.some( item => item === 'failed')
      let result2 = baseArr.every( item => item === 'warning')
      let result3 = baseArr.every( item => item === 'success')
      if (result1) this.result = this.messageObj[0]
      if (result2) this.result = this.messageObj[1]
      if (result3) this.result = this.messageObj[2]
      
    }
  }
}
</script>
<style lang='less' scoped>
//check_close.png
.check-network {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background:rgba(0,0,0,1);
  z-index: 10;
  &__content {
    padding: 24px 50px 0;
    width:558px;
    height:507px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
    border-radius:12px;
    z-index: 11;
    .menu {
      position: relative;
      text-align: center;
      &__title {
        font-size:24px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:33px;
      }
      &__close {
        position: absolute;
        right: 16px;
        top: 16px;
        width: 18px;
        height: 18px;
        background: url('../../assets/competition_close.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
  &__result {
    display: flex;
    flex-direction: column;
    .title {
      margin-bottom: 6px;
      font-weight: 500;
    }
  }
}
.box {
  display: flex;
  flex-direction: column;
  &__title {
    margin-top: 24px;
    margin-bottom: 10px;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
  }
  &__item {
    position: relative;
    margin-top: 3px;
  }
}
.line {
  margin: 27px 0 20px;
  width: 100%;
  height: 1px;
  background:rgba(237,237,238,1);
  border-radius: 1px;
}
.button {
  margin: 30px auto 0;
  width:110px;
  height:40px;
  line-height: 36px;
  text-align: center;
  font-size:16px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,255,255,1);
  background:rgba(104,149,60,1);
  border-radius:20px;
  border:2px solid rgba(67,129,31,1);
  cursor: pointer;
}
</style>